import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  SpendOverTimeByBuyerTypeQuery,
  SpendOverTimeByBuyerTypeRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const spendOverTimeByBuyerTypeQuery = graphql(`
  query spendOverTimeByBuyerType($request: SpendOverTimeByBuyerTypeRequest!) {
    spendOverTimeByBuyerType(SpendOverTimeByBuyerTypeRequest: $request) {
      points {
        buyerType
        name
        period
        totalValue
        transactionCount
      }
    }
  }
`);

/** One buyer type's spend in one time bucket. `NONE` is spend from buyers with no type. */
export type SpendBuyerTypePoint =
  SpendOverTimeByBuyerTypeQuery["spendOverTimeByBuyerType"]["points"][number];

/** Spend aggregated into time buckets, one group per top-level buyer type. */
export function useSpendOverTimeByBuyerType(
  request: SpendOverTimeByBuyerTypeRequest,
  options?: UseQueryOptions<
    SpendOverTimeByBuyerTypeQuery,
    unknown,
    SpendOverTimeByBuyerTypeQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["spendOverTimeByBuyerType", request],
    spendOverTimeByBuyerTypeQuery,
    [{ request }],
    options,
  );

  return { data: data?.spendOverTimeByBuyerType, ...rest };
}
